import React, { Component } from "react";

class GraphViewPanel extends Component {
    render() {
        const { isOverview, href, children, ...props } = this.props;

        return !isOverview ? (
            <div {...props}>
                {children}
            </div>
        ) : (

            // {/* TODO: Nav Link */}
            
            <a {...props} href={href}>
                {children}
            </a>
        );
    }
}

export default GraphViewPanel;